"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleFiltersSelected = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var ExampleFiltersSelected = function ExampleFiltersSelected(props) {
  return react_1.default.createElement("div", {
    className: "rs__filters-selected"
  }, react_1.default.createElement("h3", {
    className: "rs__filters-selected__name"
  }, "Filters Selected"), react_1.default.createElement("ul", {
    className: "rs__filters-selected__list"
  }, props.selectedFilters.map(function (selectedFilter) {
    return react_1.default.createElement(ExampleFiltersSelectedItem, {
      selectedFilter: selectedFilter,
      handleRemove: props.handleRemove
    });
  })));
};

exports.ExampleFiltersSelected = ExampleFiltersSelected;

var ExampleFiltersSelectedItem = function ExampleFiltersSelectedItem(props) {
  var _a;

  var filtersHook = (0, hooks_1.useFilters)();
  var filter = (_a = filtersHook.filters) === null || _a === void 0 ? void 0 : _a.find(function (filter) {
    return filter.handle === props.selectedFilter.key;
  });
  return react_1.default.createElement("li", {
    key: props.selectedFilter.key,
    className: "rs__filters-selected__list-item"
  }, react_1.default.createElement("label", {
    className: "rs__filters-selected__list-item-label"
  }, react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-label",
    onClick: function onClick() {
      return props.handleRemove(props.selectedFilter.key);
    }
  }, props.selectedFilter.label, ": "), (filter === null || filter === void 0 ? void 0 : filter.displayType) === "single" && filter.displayView === "range" && react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, react_1.default.createElement("span", {
    onClick: function onClick() {
      return props.handleRemove(props.selectedFilter.key, [props.selectedFilter.value.label]);
    }
  }, props.selectedFilter.value.label)), (filter === null || filter === void 0 ? void 0 : filter.displayType) === "single" && filter.displayView !== "range" && react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, react_1.default.createElement("span", {
    onClick: function onClick() {
      return props.handleRemove(props.selectedFilter.key, [props.selectedFilter.value]);
    }
  }, props.selectedFilter.value)), (filter === null || filter === void 0 ? void 0 : filter.displayType) === "multi" && filter.displayView === "range" && react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, props.selectedFilter.value.map(function (value) {
    return react_1.default.createElement("span", {
      onClick: function onClick() {
        return props.handleRemove(props.selectedFilter.key, [value.label]);
      }
    }, value.label);
  })), (filter === null || filter === void 0 ? void 0 : filter.displayType) === "multi" && filter.displayView !== "range" && react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, props.selectedFilter.value.map(function (value) {
    return react_1.default.createElement("span", {
      onClick: function onClick() {
        return props.handleRemove(props.selectedFilter.key, [value]);
      }
    }, value);
  })), (filter === null || filter === void 0 ? void 0 : filter.displayType) === "slider" && react_1.default.createElement("span", {
    className: "rs__filters-selected__list-item-value"
  }, react_1.default.createElement("span", {
    onClick: function onClick() {
      return props.handleRemove(props.selectedFilter.key, [""]);
    }
  }, "".concat(filter.displaySliderPrefix).concat(props.selectedFilter.value[0], " to ").concat(filter.displaySliderPrefix).concat(props.selectedFilter.value[1])))));
};